import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { UTILS_DEPENDENCIES, UtilsState } from "@/models/UtilsState"

export default {
	namespaced: true,
	state: () : UtilsState => {
		return {
			data: {
				[UTILS_DEPENDENCIES.MARKETS]: null,
				[UTILS_DEPENDENCIES.TECHNICIAN_STATUSES]: null,
				[UTILS_DEPENDENCIES.SERVICE_PROVIDERS]: null,
				[UTILS_DEPENDENCIES.WORK_MODELS]: null,
				[UTILS_DEPENDENCIES.DEVICES]: null
			}
		}
	},
	mutations,
	actions,
	getters
}
